import React, { useState, useRef } from 'react';
// import { Form, Input, TextArea, Debug } from 'informed';

function ContactForm() {

    const initialValues = {
        name: '',
        email: '',
        phone: '',
        message: '',
    }

    //form values
    const [formKey, setFormKey] = useState(0);
    const [values, setValues] = useState({...initialValues});
    const [error, setError] = useState(null);
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);

    const placeholders = [
        "What's for fav sando?",
        "Do you like LOTR regular or extended cuts?",
    ]
    const placeholderNum = useRef(Math.floor(Math.random() * placeholders.length));
    const placeholder = placeholders[placeholderNum.current];

    const resetForm = () => {
        setSending(false);
        setValues({...initialValues});
        setError(null);
        setFormKey(formKey + 1);
    }
    
    const onSubmit = ({ values }) => console.log(values);

    const handleSubmit = (e) => {

        e.preventDefault();

        console.log(values);

        //validate form
        if(values.phone === initialValues.phone && values.email === initialValues.email){
            setError("Leave me an email or phone number so I can get back to you.");
            return;
        }
        if(values.email !== initialValues.email){
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if(!emailPattern.test(values.email)){
                setError("Hmm, maybe double check that email address.");
                return;
            }
        }
        if(values.phone !== initialValues.phone){
            const phonePattern = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
            if(!phonePattern.test(values.phone)){
                setError("Hmm, maybe double check that phone number.");
                return;
            }
        }

        setSending(true);

        //send to "/contact.php"
        try {

            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('email', values.email);
            formData.append('phone', values.phone);
            formData.append('message', values.message);

            console.log("formData", formData)

            fetch("/contact.php", {
                method: "POST",
                body: formData,
            })
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                if(data === '1') resetForm()
            });
        }catch(err){
            console.log(err);
            setError("There was an error sending your message, please try again.");
        }

    }
    

    return (
        <form onSubmit={onSubmit} key={'form-'+formKey} className={success ? "success" : sending ? "sending" : ""}>

            {success && <div className="form-success">
                Thanks for reaching out! I'll get back to you soon.<br/>
                <button onClick={() => setSuccess(false)}>OK</button>
            </div>}
            
            <div className="form-row">
                <label>Name</label>
                <input name="name" label="Name" className={values.name === '' ? "empty" : "filled"} onChange={
                    (e) => setValues({ ...values, [e.target.name]: e.target.value })
                } />
            </div>

            <div className="form-row">
                <label>Email</label>
                <input name="email" type="email" label="Email" className={values.email === '' ? "empty" : "filled"} onChange={
                    (e) => setValues({ ...values, [e.target.name]: e.target.value })
                } />
            </div>

            <div className="form-row">
                <label>Phone</label>
                <input name="phone" type="phone" label="Phone" className={values.phone === '' ? "empty" : "filled"} onChange={
                    (e) => setValues({ ...values, [e.target.name]: e.target.value })
                } />
            </div>

            <div className="form-row">
                <label>Message</label>
                <textarea name="message" label="Message" placeholder={placeholder} className={values.message === '' ? "empty" : "filled"} onChange={
                    (e) => setValues({ ...values, [e.target.name]: e.target.value })
                } />
            </div>

            {error && <div className="form-error">{error}</div>}

            <button 
                type="submit"
                onClick={handleSubmit}
            >Send It</button>

        </form>
    )

}

export default ContactForm;